import { render } from "./create_other_service_modal.vue?vue&type=template&id=aa61fad8&scoped=true"
import script from "./create_other_service_modal.vue?vue&type=script&lang=js"
export * from "./create_other_service_modal.vue?vue&type=script&lang=js"

import "./create_other_service_modal.vue?vue&type=style&index=0&id=aa61fad8&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa61fad8"]])

export default __exports__